// extracted by mini-css-extract-plugin
export var backdropBlur = "_js-0";
export var contentCard = "_js-5";
export var frame = "_js-2";
export var image = "_js-4";
export var imagePane = "_js-3";
export var modal = "_js-1";